/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.system_noticings = { 

  destroy(el) {
    return $.ajax({
      method: "delete",
      url: this["data-url"]});
  }
};
